// helpers
import NFA from 'shared/helpers/analytics/NFAnalytics';

// types
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';

// constants
import { ACCOUNT_EVENTS } from 'shared/helpers/analytics/constants/accountEvents';

const getEventName = (key: string) => {
  if (key === 'HELP_CENTER') return ACCOUNT_EVENTS.HELP_CENTER_CLICKED;
  if (key === 'CHAT_WITH_US') return ACCOUNT_EVENTS.CHAT_SUPPORT_CLICKED;
  if (key === 'PROFILE') return ACCOUNT_EVENTS.PROFILE_CLICKED;
  return '';
};

export const trackAccountSectionClicks = (key: string) => {
  NFA.track({
    type: TRACK_TYPE.EVENT,
    event: getEventName(key),
  });
};
